export enum PortRotationEntryGeneratorTypes {
	CARGO = 'CARGO',
	CANAL_TRANSIT = 'CANAL_TRANSIT',
	BALLAST_LEG = 'BALLAST_LEG',
	SUMMARY_ROW = 'SUMMARY_ROW',
	DELIVERY_PORT = 'DELIVERY_PORT',
	REDELIVERY_PORT = 'REDELIVERY_PORT',
}
